import { Button, Modal } from "react-bootstrap";
import { createPortal } from "react-dom";
import { KTIcon } from "../../../_metronic/helpers";
import { AnnouncementData } from "../hooks/useAdminAnnouncements";

interface ViewModalProps {
  show: boolean;
  handleClose: () => void;
  data: AnnouncementData | null;
}

const modalsRoot = document.getElementById("root-modals") || document.body;

const ViewAnnouncementModal: React.FC<ViewModalProps> = ({
  show,
  handleClose,
  data,
}) => {
  return createPortal(
    <Modal
      id="kt_modal_view_announcement"
      tabIndex={-1}
      aria-hidden="true"
      dialogClassName="modal-dialog modal-dialog-centered mw-500px"
      show={show}
      onHide={handleClose}
      backdrop={true}
    >
      <div className="modal-header">
        <h2>Announcement Details</h2>
        <div
          className="btn btn-sm btn-icon btn-active-color-primary"
          onClick={handleClose}
        >
          <KTIcon className="fs-1" iconName="cross" />
        </div>
      </div>

      <div className="p-6">
        <div className="mb-4">
          <label className="form-label fw-bolder text-dark fs-6">Title</label>
          <div className="p-3 bg-light rounded">
            <span>{data?.title}</span>
          </div>
        </div>
        <div className="mb-4">
          <label className="form-label fw-bolder text-dark fs-6">
            Description
          </label>
          <div className="p-3 bg-light rounded">
            <span style={{ whiteSpace: "pre-wrap" }}>{data?.description}</span>
          </div>
        </div>
        <div className="d-flex justify-content-end">
          <Button onClick={handleClose} size="lg" variant="primary">
            Close
          </Button>
        </div>
      </div>
    </Modal>,
    modalsRoot,
  );
};

export default ViewAnnouncementModal;